import PaymentDetailsContainer from "../../../../Components/Application/Ecommerce/PaymentDetails/PaymentDetails"

const PaymentDetails = () => {
  return (
    <div className='page-body'>
      <PaymentDetailsContainer />
    </div>
  )
}

export default PaymentDetails